<template>
  <div class="survey">
    <el-card
      :style="{width: dialogWidth}"
      :body-style="{padding: ['desktop', 'laptop'].includes($mq) ? '70px' : '20px'}"
    >
      <div class="intro">
        <b>Dear {{ supporterName }},</b><br />
        <p>
          Thank you for your participation in the Leadership Growth Progress Review for testing.
          This short survey will take 5-10 minutes to complete and will be an important factor in
          accelerating {{ leaderName }}’s leadership development.
        </p>
      </div>

      <h2>Survey questions</h2>
      <el-form
        ref="surveyForm"
        :model="surveyForm"
        :rules="rules"
        label-position="top"
      >
        <!-- <el-form-item
        label="What is your relationship to the leader testing?"
        prop="q1"
      >
        <el-radio-group v-model="surveyForm.q1">
          <el-radio
            v-for="(option, key) in relationOptions"
            :key="key"
            border
            :label="option.value"
          >
            {{ option.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item> -->

        <span>
          1. Over the last 3-4 months do you believe testing has become more (or less) effective in
          demonstrating the following leadership behaviors
          (do not consider environmental factors beyond their control)?
        </span>
        <el-form-item
          v-if="leader.lga1.name"
          :label="leader.lga1.name"
          prop="question_1_lga_1"
        >
          <el-radio-group v-model="surveyForm.question_1_lga_1">
            <el-radio
              v-for="(option, key) in effectiveOptions"
              :key="key"
              border
              :label="option.value"
            >
              {{ option.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="leader.lga2.name"
          :label="leader.lga2.name"
          prop="question_1_lga_2"
        >
          <el-radio-group v-model="surveyForm.question_1_lga_2">
            <el-radio
              v-for="(option, key) in effectiveOptions"
              :key="key"
              border
              :label="option.value"
            >
              {{ option.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <span>
          2. Did testing communicate to you these leadership growth areas over the last 3-4 months?
        </span>
        <el-form-item
          v-if="leader.lga1.name"
          :label="leader.lga1.name"
          prop="question_2_lga_1"
        >
          <el-radio-group v-model="surveyForm.question_2_lga_1">
            <el-radio
              v-for="(option, key) in frequencyOptions"
              :key="key"
              border
              :label="option.value"
            >
              {{ option.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="leader.lga2.name"
          :label="leader.lga2.name"
          prop="question_2_lga_2"
        >
          <el-radio-group v-model="surveyForm.question_2_lga_2">
            <el-radio
              v-for="(option, key) in frequencyOptions"
              :key="key"
              border
              :label="option.value"
            >
              {{ option.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="3. Did they follow up with you and ask you for feedback and/or feedforward
      suggestions in these leadership growth areas over the last 3-4 months?"
          prop="question_3"
        >
          <el-radio-group v-model="surveyForm.question_3">
            <el-radio
              v-for="(option, key) in followOptions"
              :key="key"
              border
              :label="option.value"
            >
              {{ option.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="4. Did they share their action plan with you over the last 3-4 months?"
          prop="question_4"
        >
          <el-radio-group v-model="surveyForm.question_4">
            <el-radio
              v-for="(option, key) in frequencyOptions"
              :key="key"
              border
              :label="option.value"
            >
              {{ option.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="5. Did they implement their action plan and
        make change visible to you over the last 3-4 months?"
          prop="question_5"
        >
          <el-radio-group v-model="surveyForm.question_5">
            <el-radio
              v-for="(option, key) in frequencyOptions"
              :key="key"
              border
              :label="option.value"
            >
              {{ option.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="6. What has testing done in their leadership growth areas over the past 3-4 months
        to become a more effective leader and what did you find particularly effective?
        You can add comments in your preferred language:"
          prop="question_6"
        >
          <el-input
            v-model="surveyForm.question_6"
            type="textarea"
            :autosize="{minRows: 4, maxRows: 6}"
            placeholder="Please input"
          />
        </el-form-item>

        <el-form-item
          label="7. What can they do in their leadership growth areas to become more effective as
        a leader in the next 3-4 months? You can add comments in your preferred language:"
          prop="question_7"
        >
          <el-input
            v-model="surveyForm.question_7"
            type="textarea"
            :autosize="{minRows: 4, maxRows: 6}"
            placeholder="Please input"
          />
        </el-form-item>

        <el-form-item
          label="8. Are there any additional comments you would you like to share with testing?
        You can add comments in your preferred language:"
          prop="question_8"
        >
          <el-input
            v-model="surveyForm.question_8"
            type="textarea"
            :autosize="{minRows: 4, maxRows: 6}"
            placeholder="Please input"
          />
        </el-form-item>

        <el-form-item
          label="9. Did they change their overall leadership effectiveness over the last 3-4 months
        (Do not consider environmental factors beyond their control)?"
          prop="question_9"
        >
          <el-radio-group v-model="surveyForm.question_9">
            <el-radio
              v-for="(option, key) in effectiveOptions"
              :key="key"
              border
              :label="option.value"
            >
              {{ option.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item class="submitItem">
          <el-button
            type="primary"
            @click="submit"
          >
            Survey Submit
          </el-button>
          <br />
          <span>
            By submitting the survey you are complying with our survey data collection policies.
          </span>
        </el-form-item>

      <!-- END -->
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '@/api';
import DialogSetting from '@/mixins/dialog';

export default {
  mixins: [DialogSetting],

  props: {
    leader: {
      type: Object,
      default() {
        return {
          lga1: {},
          lga2: {},
        };
      },
    },
    supporter: {
      type: Object,
      default() {
        return {};
      },
    },
    status: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      surveyForm: {
        question_1_lga_1: '',
        question_1_lga_2: '',
        question_2_lga_1: '',
        question_2_lga_2: '',
        question_3: '',
        question_4: '',
        question_5: '',
        question_6: '',
        question_7: '',
        question_8: '',
        question_9: '',
      },
      rules: {
        question_1_lga_1: [
          { required: true, message: 'This answer is required', trigger: 'change' },
        ],
        question_1_lga_2: [
          { required: true, message: 'This answer is required', trigger: 'change' },
        ],
        question_2_lga_1: [
          { required: true, message: 'This answer is required', trigger: 'change' },
        ],
        question_2_lga_2: [
          { required: true, message: 'This answer is required', trigger: 'change' },
        ],
        question_3: [
          { required: true, message: 'This answer is required', trigger: 'change' },
        ],
        question_4: [
          { required: true, message: 'This answer is required', trigger: 'change' },
        ],
        question_5: [
          { required: true, message: 'This answer is required', trigger: 'change' },
        ],
        question_9: [
          { required: true, message: 'This answer is required', trigger: 'change' },
        ],
      },
      relationOptions: [
        {
          value: 'manager',
          label: 'Manager',
        },
        {
          value: 'peer',
          label: 'Peer',
        },
        {
          value: 'direct_report',
          label: 'Direct Report',
        },
        {
          value: 'other',
          label: 'Other',
        },
      ],
      effectiveOptions: [
        {
          value: -3,
          label: '(-3)\nMuch Less Effective',
        },
        {
          value: -2,
          label: '(-2)\nNoticeably Less Effective',
        },
        {
          value: -1,
          label: '(-1)\nLittle Less Effective',
        },
        {
          value: 0,
          label: '(0)\nNo Change',
        },
        {
          value: 1,
          label: '(1)\nLittle More Effective',
        },
        {
          value: 2,
          label: '(2)\nNoticeably More Effective',
        },
        {
          value: 3,
          label: '(3)\nMuch More Effective',
        },
        {
          value: 4,
          label: 'No Improvement Needed',
        },
      ],
      frequencyOptions: [
        {
          value: 0,
          label: 'Never',
        },
        {
          value: 1,
          label: 'Very Rarely',
        },
        {
          value: 2,
          label: 'Rarely',
        },
        {
          value: 3,
          label: 'Occasionally',
        },
        {
          value: 4,
          label: 'Frequently',
        },
        {
          value: 5,
          label: 'Very Frequently',
        },
      ],
      followOptions: [
        {
          value: 0,
          label: 'No Follow Up',
        },
        {
          value: 1,
          label: 'A Little Follow Up',
        },
        {
          value: 2,
          label: 'Some Follow Up',
        },
        {
          value: 3,
          label: 'Frequent Follow Up',
        },
        {
          value: 4,
          label: 'Consistent & Periodic Follow Up',
        },
      ],
    };
  },

  computed: {
    supporterName() {
      let name = this.supporter.first_name;
      if (this.supporter.last_name) name += ` ${this.supporter.last_name}`;
      return name;
    },

    leaderName() {
      let name = this.leader.first_name;
      if (this.leader.last_name) name += ` ${this.leader.last_name}`;
      return name;
    },
  },

  methods: {
    submit() {
      console.log(this.surveyForm);
      this.$refs.surveyForm.validate(async (valid) => {
        if (valid) {
          try {
            const { id } = this.$route.params;
            await api.submitSurvey(id, this.surveyForm);
            this.$emit('update:status', 'just_submitted');
          } catch (err) {
            if (err.msg) {
              this.$message.error(err.msg);
            } else {
              this.$message.error('An error happened while saving your answers.');
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.survey {
  display: flex;
  justify-content: center;

  .el-card {
    display: inline-block;
    text-align: left;
  }

  .el-radio {
    max-width: 100px;
    width: 100px;
    height: 110px;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-right: 5px;
    margin-left: 0 !important;
    vertical-align: top;

    .el-radio__input {
      display: block;
      text-align: center;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      border-bottom-color: rgb(220, 223, 230);
      padding: 10px 0;
    }

    .el-radio__input.is-checked {
      border-color: #409eff;
    }

    .el-radio__label {
      max-width: 90px;
      width: 90px;
      display: block;
      // white-space: normal;
      white-space: pre-line;
      word-break: break-word;
      text-align: center;
      padding-left: 0;
      margin: 0 5px;
    }
  }

  .submitItem {
    text-align: center;
  }
}
</style>
